/*
|--------------------------------------------------------------------------
| ZF CUSTOM CODE
|--------------------------------------------------------------------------
|
| File        : zf-size-confirm.js
| Description : Displays size confirmation popup before the
|               first Add to Cart if customer has not
|               explicitly selected a size.
|
|--------------------------------------------------------------------------
*/

document.addEventListener("DOMContentLoaded", () => {
    /*------------------------------------------------------------------
      ZF : Shared Namespace
      ------------------------------------------------------------------*/

    window.ZF = window.ZF || {};

    window.ZF.Size = {
        changed: false,
        confirmed: false,
        submitting: false,
    };

    window.ZF.Size.pendingButton = null;
    window.ZF.Size.pendingButtonText = "Add to Cart";

    /*------------------------------------------------------------------
          ZF : Elements
      ------------------------------------------------------------------*/

    const zfOverlay = document.getElementById("zf-size-confirm-overlay");

    const zfDetails = document.getElementById("zf-confirm-details");

    const zfChangeButton = document.getElementById("zf-change-size");

    const zfConfirmButton = document.getElementById("zf-confirm-size");

    const zfAddToCartButton = document.querySelector(
        '.product-form__submit[name="add"]',
    );

    const zfBuyNowButton = document.querySelector(
        ".shopify-payment-button__button"
    );

    if (!zfOverlay || !zfAddToCartButton) {
        return;
    }

    /*------------------------------------------------------------------
        ZF : Show Popup
    ------------------------------------------------------------------*/

    function zfOpenPopup() {
        /*------------------------------------------------------------
            ZF CUSTOM CODE
            Read measurements directly from the shared
            size chart JSON.
        ------------------------------------------------------------*/

        zfConfirmButton.textContent = window.ZF.Size.pendingButtonText;

        const selectedSizeInput = document.querySelector(
            'input[name="Size"]:checked',
        );

        if (!selectedSizeInput) {
            return;
        }

        const size = selectedSizeInput.value;

        const info = window.zfSizeChart[size];

        if (!info) {
            return;
        }

        const bodyChest = info.body_chest || null;
        const chest = info.garment_chest || "-";
        const length = info.garment_length || "-";

        const bodyChestRow = bodyChest
            ? `
            <div class="zf-confirm-row">
            <span>Fits Chest</span>
            <strong>${bodyChest}</strong>
            </div>
            `
            : "";

        zfDetails.innerHTML = `
            <div class="zf-confirm-row">
            <span>Selected Size</span>
            <strong>${size}</strong>
            </div>

            ${bodyChestRow}

            <div class="zf-confirm-row">
            <span>Garment Chest</span>
            <strong>${chest}"</strong>
            </div>

            <div class="zf-confirm-row">
            <span>Garment Length</span>
            <strong>${length}"</strong>
            </div>

            <div class="zf-confirm-warning">
            Actual garment measurements may vary by ±0.5 inch.
            </div>
        `;
        zfOverlay.style.display = "flex";
    }

    /*-----------------------------------------------------------------
        ZF : Hide Popup
    ------------------------------------------------------------------*/

    function zfClosePopup() {
        zfOverlay.style.display = "none";
    }

    /*------------------------------------------------------------------
    ZF : Close On Overlay Click
    ------------------------------------------------------------------*/

    zfOverlay.addEventListener("click", (event) => {
        if (event.target === zfOverlay) {
            zfClosePopup();
        }
    });

    /*------------------------------------------------------------------
        ZF : Close On Escape
    ------------------------------------------------------------------*/

    document.addEventListener("keydown", (event) => {
        if (event.key === "Escape" && zfOverlay.style.display === "flex") {
            zfClosePopup();
        }
    });

    /*------------------------------------------------------------------
        ZF : Detect Manual Size Selection
    ------------------------------------------------------------------*/

    document.querySelectorAll('input[name="Size"]').forEach((input) => {
        input.addEventListener("change", () => {
            window.ZF.Size.changed = true;
        });
    });

    /*------------------------------------------------------------------
        ZF : Intercept Add To Cart
    ------------------------------------------------------------------*/

    zfAddToCartButton.addEventListener(
        "click",
        function (event) {

            /*--------------------------------------------------------------
                ZF CUSTOM CODE
                Skip popup if product has no size chart.
            --------------------------------------------------------------*/

            if (!window.zfSizeChart) {
                return;
            }

            /*--------------------------------------------------------------
                Already confirmed
            --------------------------------------------------------------*/

            if (
                window.ZF.Size.confirmed ||
                window.ZF.Size.changed ||
                window.ZF.Size.submitting
            ) {
                return;
            }

            /*--------------------------------------------------------------
                Stop Shopify submission
            --------------------------------------------------------------*/

            event.preventDefault();

            event.stopPropagation();

            window.ZF.Size.pendingButton = zfAddToCartButton;
            window.ZF.Size.pendingButtonText = "Add to Cart";

            zfOpenPopup();
        },
        true,
    );



    if (zfBuyNowButton) {

        zfBuyNowButton.addEventListener(
            "click",
            function (event) {

                if (!window.zfSizeChart) {
                    return;
                }

                if (
                    window.ZF.Size.confirmed ||
                    window.ZF.Size.changed ||
                    window.ZF.Size.submitting
                ) {
                    return;
                }

                event.preventDefault();
                event.stopPropagation();

                window.ZF.Size.pendingButton = zfBuyNowButton;
                window.ZF.Size.pendingButtonText = "Continue to Checkout";

                zfOpenPopup();

            },
            true
        );

    }

    /*------------------------------------------------------------------
        ZF : Change Size
    ------------------------------------------------------------------*/

    zfChangeButton.addEventListener("click", () => {
        zfClosePopup();
    });

    /*------------------------------------------------------------------
        ZF : Confirm Size
    ------------------------------------------------------------------*/

    zfConfirmButton.addEventListener("click", () => {

        /*--------------------------------------------------------------
            Mark as confirmed
        --------------------------------------------------------------*/

        window.ZF.Size.confirmed = true;

        zfClosePopup();

        /*--------------------------------------------------------------
            Prevent duplicate submissions
        --------------------------------------------------------------*/

        if (window.ZF.Size.submitting) {
            return;
        }

        window.ZF.Size.submitting = true;

        /*--------------------------------------------------------------
            Continue the original action
        --------------------------------------------------------------*/

        const pendingButton = window.ZF.Size.pendingButton;

        if (!pendingButton) {
            console.error("ZF: Pending button not found.");
            window.ZF.Size.submitting = false;
            return;
        }

        pendingButton.click();

        /*--------------------------------------------------------------
            Reset submission lock
        --------------------------------------------------------------*/

        setTimeout(() => {
            window.ZF.Size.submitting = false;
        }, 1000);

    });
});
